import { useEffect, useState, type FormEvent, type ReactNode } from "react";
import type { Session } from "@supabase/supabase-js";
import { supabase } from "../services/supabase";

export function AuthGate({ children }: { children: (session: Session) => ReactNode }) {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("dguerreroe921@gmail.com");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const inviteFlow = window.location.hash.includes("type=invite") || window.location.hash.includes("type=recovery");

  useEffect(() => {
    if (!supabase) {
      setLoading(false);
      return;
    }
    void supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setLoading(false);
    });
    const { data } = supabase.auth.onAuthStateChange((_event, nextSession) => setSession(nextSession));
    return () => data.subscription.unsubscribe();
  }, []);

  const signIn = async (event: FormEvent) => {
    event.preventDefault();
    if (!supabase) return;
    setMessage("Ingresando...");
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setMessage(error ? error.message : "Sesión iniciada.");
  };

  const setInitialPassword = async (event: FormEvent) => {
    event.preventDefault();
    if (!supabase || !session) return;
    setMessage("Guardando contraseña...");
    const { error } = await supabase.auth.updateUser({ password });
    if (error) {
      setMessage(error.message);
      return;
    }
    await supabase.from("profiles").upsert({ id: session.user.id, full_name: "Douglas David Guerrero Espitaleta" });
    window.history.replaceState({}, document.title, window.location.pathname);
    setMessage("Contraseña configurada.");
  };

  if (loading) return <AuthScreen title="Conectando con JobPilot..." />;
  if (!supabase) return <AuthScreen title="Falta configurar Supabase." />;
  if (session && inviteFlow) {
    return <AuthScreen title="Crea tu contraseña de JobPilot"><form onSubmit={setInitialPassword}><input type="password" minLength={10} value={password} onChange={(event) => setPassword(event.target.value)} placeholder="Nueva contraseña segura" required /><button type="submit">Guardar y continuar</button><p>{message}</p></form></AuthScreen>;
  }
  if (!session) {
    return <AuthScreen title="Ingresa a JobPilot"><form onSubmit={signIn}><input type="email" value={email} onChange={(event) => setEmail(event.target.value)} required /><input type="password" value={password} onChange={(event) => setPassword(event.target.value)} placeholder="Contraseña" required /><button type="submit">Ingresar</button><p>{message || "Si recibiste una invitación, abre primero el enlace del correo."}</p></form></AuthScreen>;
  }
  return <>{children(session)}</>;
}

function AuthScreen({ title, children }: { title: string; children?: ReactNode }) {
  return <main className="auth-shell"><section className="auth-card"><span className="brand-mark">JP</span><h1>{title}</h1>{children}</section></main>;
}
